export const EmployeeVI ={
    "employee": {

        "title": {
            "delete": "Bạn có chắc chắn muốn xóa không?",
            "create": "Tạo mới",
            "update": "Cập nhật",
            "buttonKeep" : "Giữ trang sau khi",
            "buttonGo" : "Chuyển về danh sách sau khi",
            "receptionFile" : "Cập nhật thông tin tiếp nhận",
            "education" : "Cập nhật thông tin học vấn",
            "experience": "Cập nhật kinh nghiệm làm việc",
            "family" : "Cập nhật thông tin gia đình",
            "communist" : "Cập nhật lịch sử đảng viên",
            "status" : "Cập nhật trạng thái",
            "disableAccount": "Đóng tài khoản của hồ sơ nhân sự này",
            "reason" : "Lý do nghỉ",
            "salary": "Cập nhật lương & phụ cấp",
            "career": "Cập nhật lịch sử công việc",
            "concurrently" : "Kiêm nhiệm",
            "insurance": "Cập nhật thông tin bảo hiểm",
            "insuranceRate": "Tỷ lệ bảo hiểm",
            "workHistory" : " Lịch sử công việc ",
            "fine" : "Kỷ luật nội bộ ",
            "rewardWelfare" : "Khen thưởng / phúc lợi "
        },
        "message": {
            "receptionFile": "Cập nhật thông tin tiếp nhận thành công",
            "updateEmployeeCommunist" : "Cập nhật thông tin học vấn thành công !",
            "updateEmployeeReceipt" : "Cập nhật lịch sử đảng viên thành công !",
            "updateEmployeeEducation" : "Cập nhật thông tin học vấn thành công !",
            "updateEmployeeExperience" : "Cập nhật kinh nghiệm làm việc thành công !",
            "updateEmployeeFamily" : "Cập nhật thông tin gia đình thành công !",
            "updateEmployeeStatus" : "Cập nhật trạng thái nhân viên thành công !",
            "emailNotEntered":"Email chưa được nhập!"


        }
    },
    "employeesSider": {
        "headingLabel": "Quản lý nhân sự",
        "listEmployee": "Tất cả nhân viên",
        "importEmployee": "Import danh sách nhân sự",
        "exportEmployee": "Export danh sách nhân sự",
        "createEmployee": "Tạo mới nhân sự",
        "working": "Đang làm việc",
        "updateEmployee": "Cập nhật nhân sự",
        "temporaryLeave": "Nghỉ tạm thời",
        "registration" : "Nghỉ việc",
        "all" : "Tất cả",
        "decision": {
            "headingLabel": "Quyết định",
            "reward": "Quyết định khen thưởng",
            "appointment": "Quyết định bổ nhiệm",
            "transfer": "Quyết định điều chuyển",
            "contract": "Quyết định chấm dứt hợp đồng",
            "salary": "Quyết định tăng/giảm lương",
            "admission": "Quyết định tiếp nhận",
            "discipline": "Kỷ luật lao động"
        },
        "personnelRecord":"Hồ sơ nhân sự",
        "resignation":"Nghỉ việc",
        "laborContract":"Hợp đồng",
        "insurance": {
            "label" : "Bảo hiểm",
            "estimatedIncreasing":"Tăng dự kiến",
            "estimatedDecreases":"Giảm dự kiến",
            "paymentHistory":"Lịch sử đóng",
        },
        "competencyAssessment":"Đánh giá nhân sự",
    },
    "employeeForm": {
        "titleSideBar": {
            "basic": "Thông tin cá nhân",
            "contact": "Thông tin liên hệ",
            "Family": "Thông tin gia đình & người phụ thuộc",
            "education": "Trình độ học vấn",
            "payment": "Thông tin thanh toán",
            "communist": "Lịch sử đảng viên",
            "experience": "Kinh nghiệm làm việc",
            "imageProfile": "Ảnh hồ sơ",
            "other": "Thông tin khác"

        },
        "titleTab": {
            "employee": "Thông tin nhân sự",
            "contract": "Hợp đồng"
        },
        "title": {
            "employeeCode": "Nhập mã nhân sự",
            "timekeepingCode": "Mã chấm công",
            "docCode": "Mã hồ sơ",
            "name": "Họ tên",
            "birthDay": "Ngày sinh",
            "gender": "Giới tính",
            "placeOfBirth" : "Nơi Sinh",
            "placeOfOrigin" : "Thường quán",
            "idNumber" : "CMT/Hộ chiếu",
            "idNumberIssueDate": "Ngày Cấp",
            "idNumberIssueBy" : "Nơi Cấp",
            "maritalStatus" : "Tình trạng hôn nhân",
            "single" : "Độc thân",
            "engaged" : "Đã đính hôn",
            "married" : "Đã kết hôn",
            "separated" : "Ly Thân",
            "divorced" : "ly hôn",
            "widow" : "Góa phụ",
            "nationality" : "Quốc Tịch",
            "ethnic" : "Dân tộc",
            "religion" : "Tôn giáo",
            "bank" : "Ngân hàng",
            "bankBranch" : "Chi nhánh",
            "bankAccountNo" : "Số tài khoản",
            "bankAccountName" : "Tên tài khoản",
            "taxNumber" : "Mã số thuế cá nhân",
            "joinDate" : "Ngày vào",
            "joinMainDate"  : "Ngày vào chính thức",
            "educationType"  : "Trình độ phổ thông",
            "academicLevel"  : "Trình độ học vấn cao nhất",
            "managerName" : "Người quản lý trực tiếp",
            "phone" : "Danh sách số điện thoại",
            "email"  : "Danh sách email",
            "homeAddressDetail" : "Thường trú",
            "homeAddress" : "Địa chỉ",
            "currentAddressDetail" : "Chỗ ở hiện nay",
            "currentAddress" : "Địa chỉ",
            "relative" : "Mối quan hệ",
            "jobTitle" : "Nghề nghiệp",
            "true" : "Có",
            "false" : "Không",
            "isDependent" : "Người phụ thuộc",
            "dependentFrom" : "Từ ngày",
            "dependentTo" : "Tới ngày",
            "dependentTaxNo" : "Mã số thuế",
            "fromDate" : "Từ ngày",
            "toDate" : "Đến ngày",
            "fromMonth" : "Từ tháng",
            "toMonth" : "Đến tháng",
            "typeId" : "Hình thức đào tạo",
            "trainingLevel" : "Trình độ học vấn",
            "place" : "Nơi đào tạo",
            "specialization" : "Chuyên Ngành",
            "code" : "Số thẻ",
            "status" : "Hình thức",
            "joinAddress" : "Nơi kết nạp",
            "joinTransfer": "Nơi điều chuyển",
            "companyName": "Công ty",
            "positionName": "Vị trí",
            "referenceName": "Người tham chiếu",
            "referencePhone": "Số điện thoại",
            "workDesc": "Mô tả công việc",
            "male" : "Nam",
            "female" : "Nữ",
            "other" : "Khác",
            "note" : "Ghi chú",
            "fontId" : "Ảnh mặt trước",
            "backId" : "Ảnh mặt sau",
            "id_Card" : "Ảnh chứng minh thư nhân dân",
            "avatar" : "Ảnh đại diện"
        },
        "placeHolder": {
            "employeeCode": "Nhập mã nhân sự",
            "timekeepingCode": "VN.100",
            "docCode": "VPHN.007",
            "name": "Nguyen Van A",
            "birthDay": "dd/mm/yyy",
            "gender": "Chọn giới tính",
            "placeOfBirth" : "Nhập nơi Sinh",
            "placeOfOrigin" : "Nhập nguyên quán",
            "idNumber" : "CMT/Hộ chiếu",
            "idNumberIssueDate": "dd/mm/yyyy",
            "idNumberIssueBy" : "Nơi Cấp",
            "maritalStatus" : "Tình trạng hôn nhân",
            "single" : "Độc thân",
            "engaged" : "Đã đính hôn",
            "married" : "Đã kết hôn",
            "separated" : "Ly Thân",
            "divorced" : "ly hôn",
            "widow" : "Góa phụ",
            "nationality" : "Quốc Tịch",
            "ethnic" : "Dân tộc",
            "religion" : "Tôn giáo",
            "bank" : "Ngân hàng",
            "bankBranch" : "Chi nhánh",
            "bankAccountNo" : "Số tài khoản",
            "bankAccountName" : "Tên tài khoản",
            "taxNumber" : "Mã số thuế cá nhân",
            "joinDate" : "Ngày vào",
            "joinMainDate"  : "Ngày vào chính thức",
            "educationType"  : "Trình độ phổ thông",
            "academicLevel"  : "Trình độ học vấn cao nhất",
            "managerName" : "Người quản lý trực tiếp",
            "phone" : "Danh sách số điện thoại",
            "email"  : "Danh sách email",
            "homeAddressDetail" : "Số 159 Lê lợi ",
            "homeAddress" : "ví dụ: Hà Cầu, Hà Đông, Hà Nội",
            "currentAddressDetail" : "ví dụ: P2001 – CT8 – Mỗ Lao",
            "currentAddress" : "  Mỗ Lao, Hà Đông, Hà Nội",
            "relative" : "Mối quan hệ",
            "jobTitle" : "Nghề nghiệp",
            "true" : "Có",
            "false" : "Không",
            "isDependent" : "Người phụ thuộc",
            "dependentFrom" : "Từ ngày",
            "dependentTo" : "Tới ngày",
            "dependentTaxNo" : "Mã số thuế",
            "fromDate" : "Từ ngày",
            "toDate" : "Đến ngày",
            "fromMonth" : "Từ tháng",
            "toMonth" : "Đến tháng",
            "typeId" : "Hình thức đào tạo",
            "trainingLevel" : "Trình độ học vấn",
            "place" : "Nơi đào tạo",
            "specialization" : "Chuyên Ngành",
            "code" : "Số thẻ",
            "status" : "Hình thức",
            "joinAddress" : "Nơi kết nạp",
            "joinTransfer": "Nơi điều chuyển",
            "companyName": "Công ty",
            "positionName": "Vị trí",
            "referenceName": "Người tham chiếu",
            "referencePhone": "Số điện thoại",
            "workDesc": "Mô tả công việc",
            "male" : "Nam",
            "female" : "Nữ",
            "other" : "Khác",
            "note" : "Ghi chú"

        },

        "required" : {
            "employeeCode" : "Vui lòng nhập mã nhân sự !",
            "name" : "Vui lòng nhập họ và tên !",
            "gender" : "Nhập giới tính !",
            "maritalStatus" : "Nhập tình trạng hôn nhân!",
            "relative" : "Yêu cầu nhập mối qua hệ",
            "isDependent" : "Chọn ngừoi phụ thuộc",
            "timeKeepingCode" : "Mã chấm công không được để trống",
            "docCode" : "Mã hồ sơ không được để trống!"

        },
        "toolTip" : {
            "employeeCode" : "Cấu trúc mã: {date,'dmy',\"312\"}\nMã được qui định tự động, không cho phép sửa",
            "timeKeepingCode" : "Nhập mã chấm công hoặc nhập mã máy và mã chấm công dạng MAMAY.MACHAMCONG",
            "docCode" : "Dùng để lưu mã hồ sơ cứng phục vụ cho tìm kiếm",
            "phone" : "Khi có nghiệp vụ sử dụng số điện thoại, hệ thống sẽ ưu tiên lấy số đầu tiên",
            "email" : "Khi có nghiệp vụ sử dụng email, hệ thống sẽ gửi cho tất cả các email",
            "homeAddress" : "Gõ tên địa danh, hệ thống sẽ tự gợi ý cho bạn",
            "currentAddress" : "[Chỗ ở hiện nay] Địa chỉ"
        }


    },
    "employeeColumns" : {
        "employeeCode" : "Mã nhân sự",
        "timeKeepingCode" : "Mã chấm công",
        "name" : "Họ và tên",
        "department" : "Phòng ban",
        "jobPosition" : "Vị Trí",
        "jobTitle" : "Chức vụ",
        "age" : "Tuổi",
        "gender" : "Giới tính",
        "joinDate" : "Ngày vào",
        "birthDay":"Ngày sinh",
    },
    "employeeWelfare": {
        "welfare": "Khen thưởng / Phúc lợi",
        "account": "Tạo tài khoản",
        "createAccount": "Bạn có muốn tạo tài khoản cho nhân viên này không?",
        "paid": "Đã thanh toán",
        "includedInSalary": "Tính vào lương",
        "date": "Ngày hưởng",
        "name": "Tên phúc lợi",
        "money": "Số tiền",
        "type": "Hình thức"
    },

    "tabEmployees": {
        "tab" : {
            "details" :"Sơ yếu lý lịch",
            "receptionFile" : "Tiếp nhận",
            "receptionProcedure" : "Thủ tục tiếp nhận",
            "contract": "Hợp đồng",
            "insurance" : "Bảo hiểm",
            "resignation" : "Thôi việc",
            "attachments" : "Đính kèm",
            "jobDetail" : "Công việc",
            "salaryEmployee" : "Lương & phụ cấp"
        }
    },
    "errorEmployee":{
        "dateBirth" : "Ngày sinh không được lớn hơn ngày hiện tại ",
        "phone" : "Số điện thoại không hợp lệ ",
        "fromDate" : "Từ ngày không được lớn hơn ngày hiện tại ",
        "dependNull" : "Phụ thuộc từ ngày chưa nhập ",
        "index" : "Ở dòng thứ ",
        "toFrom" : "Đến ngày không được nhỏ hơn từ ngày ",
        "experienceDate" : "Thời gian kinh nghiệm không được lớn hơn thời gian hiện tại ",
        "experienceFromTo" : "Thời gian bắt đầu có kinh nghiệm không được lớn hơn thời gian kết thúc có kinh nghiệm"
    }

}
